import { action } from 'satcheljs/lib/legacy';
import { getGetStartedTasks } from '../services/getGetStartedTasks';
import { getStore } from '../store/store';
import { getGetStartedTaskProperties } from '../utils/getGetStartedTaskProperties';
import { GetStartedTaskStoreMap } from '../store/schema/GetStartedTaskStoreMap';

export default action('initializeGetStartedTasks')(async function initializeGetStartedTasks() {
    const response = await getGetStartedTasks();
    let tasksIdentitiesDefinedOnClient = getGetStartedTaskProperties().map(t => t.identity);
    let tasks: GetStartedTaskStoreMap = {};

    if (response && response.length > 0) {
        response.forEach(serverTask => {
            if (tasksIdentitiesDefinedOnClient.includes(serverTask.identity)) {
                tasks[serverTask.identity] = {
                    identity: serverTask.identity,
                    status: serverTask.status,
                    clicked: false,
                };
            }
        });

        if (Object.keys(tasks).length > 0) {
            getStore().tasks = tasks;
        }
    }
});
